import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import moment from "moment";

const DateCell: FC<Props> = ({ element }) => {

  const isCurrentDate = moment(element.FromDate).isSame(new Date(), "day");

  const isTomorrow = moment(element.FromDate).isSame(
    moment(new Date()).subtract(1, "day").startOf("day"),
    "day"
  );

  const isTomorrow_2 = moment(element.FromDate).isSame(
    moment(new Date()).subtract(2, "day").startOf("day"),
    "day"
  );

  let data = element.FromDate
    ? moment(element.FromDate).format("DD.MM.YY HH:mm").toString()
    : "";

  if (isCurrentDate) {
    data = `Dzisiaj | ${moment(element.FromDate).format("HH:mm").toString()}`;
  }

  if (isTomorrow) {
    data = `Wczoraj | ${moment(element.FromDate).format("HH:mm").toString()}`;
  }

  if (isTomorrow_2) {
    data = `Przedwczoraj | ${moment(element.FromDate)
      .format("HH:mm")
      .toString()}`;
  }

  return (
    <div className={styles.wrapper}>
      <div className={`${styles.stack}`}>
        <div className={styles.sender}>{data}</div>
      </div>
    </div>
  );
};

export default DateCell;
